import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import { observer } from "mobx-react";
import {
  FoundationColorTokens,
  Spacing,
  Typography as LeoTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";
import { Instance } from "mobx-state-tree";
import { SINGLE_SPACING } from "@pulse/shared-components";
import { SPoCDownloadAndUnmapStore } from "../../store/SPoCDownloadAndUnmapStore";

interface UnmapMultipleSPoCsValidationLoaderProps {
  t: TFunction;
  spacing: Spacing;
  tokens: FoundationColorTokens<string>;
  typography: LeoTypography;
  spocDownloadAndUnmapStore: Instance<typeof SPoCDownloadAndUnmapStore> | null;
}

export const UnmapMultipleSPoCsValidationLoader = observer(
  ({
    t,
    spacing,
    tokens,
    typography,
    spocDownloadAndUnmapStore,
  }: UnmapMultipleSPoCsValidationLoaderProps): React.ReactElement => {
    return (
      <Stack
        padding={spacing.spaceXL}
        alignItems="center"
        spacing={spacing.spaceXS}
        textAlign="center"
        width="100%"
      >
        <CircularProgress
          size="32px"
          style={{
            color: tokens.iconPrimary,
          }}
        />
        <Typography sx={{ ...typography.b2, color: tokens.labelPrimary }}>
          {t("projects.userAccess.unmapSPoCs.validatingFile", {
            defaultValue: t("projects.respondentList.validatingBulkSPoCFile"),
          })}
          {SINGLE_SPACING}
          <Typography
            component={"span"}
            sx={{ ...typography.s1, color: tokens.labelPrimary }}
          >
            {spocDownloadAndUnmapStore?.fileName}
          </Typography>
          {t("projects.userAccess.unmapSPoCs.pleaseWait", {
            defaultValue: t("projects.respondentList.pleaseWait"),
          })}
        </Typography>
      </Stack>
    );
  },
);
